import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasAnyOfRoles } from '../constants/roles';

const ProtectedRoute = ({ allowedRoles }) => {
  const { isAuthenticated, hasRole } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles && allowedRoles.length > 0) {
    const ok = hasAnyOfRoles(hasRole, allowedRoles);
    if (!ok) return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;


